/** The shape of `usePublicFrontendTranslation()`'s `t`, for pure copy helpers. */
export type Translate = (value: string, options?: Record<string, unknown>) => string;

const PLACEHOLDER = /\{(\w+)\}/g;

/** Fills `{name}` placeholders; unknown placeholders are left as written. */
export function formatMessage(template: string, options?: Record<string, unknown>): string {
  if (!options) return template;
  return template.replace(PLACEHOLDER, (placeholder, name: string) =>
    Object.hasOwn(options, name) ? String(options[name]) : placeholder);
}

/** The distinct `{name}` placeholders a message uses. */
export function placeholderNames(template: string): Set<string> {
  return new Set(Array.from(template.matchAll(PLACEHOLDER), (match) => match[1]));
}

/** Source-English fallback for copy helpers called outside a translation context (tests, server). */
export const sourceEnglish: Translate = formatMessage;
